import React from "react";

export default function Profile({ language }) {
  return (
    <div className="profileContainer">
      <div className="profile">
        <div className="profile-infoCol">
        {language === "en" ? (
          <h1 className="profile-heading">Profile</h1>
          ) : (
          <h1 className="profile-heading">Profil</h1>
          )}
          <div></div>
          <div className="profile-infoText">
            <div className="profile-box">
              <div className="right">
                <h3 className="content-heading">Profile</h3>
                <div className="two-part">
                  <div className="keys">
                    {language === "en" ? (
                      <p>Birth Date</p>
                    ) : (
                      <p>Doğum Tarihi</p>
                    )}
                    {language === "en" ? <p>City</p> : <p>Şehir</p>}
                    {language === "en" ? (
                      <p>Education Status</p>
                    ) : (
                      <p>Eğitim Durumu</p>
                    )}
                    <br />
                    <br />
                    {language === "en" ? <p>Position</p> : <p>Pozisyon</p>}
                  </div>
                  <div className="values">
                    {" "}
                    <p>21.08.1997</p>
                    <p>Ankara</p>
                    {language === "en" ? (
                      <p>İzmir Institute of Technology,Architecture,2022</p>
                    ) : (
                      <p>İzmir Yüksek Teknoloji Enstitüsü,Mimarlık,2022</p>
                    )}
                    <p>Frondend Developer,UI</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="about-box">
              {language === "en" ? (
                <h3 className="content-heading">About Me</h3>
              ) : (
                <h3 className="content-heading">Hakkımda</h3>
              )}
              {language === "en" ? (
                <p className="aboutMeText">
                  I graduated from İzmir Institute of Technology. Currently, I
                  am enrolled in the Workintech 6-month accelerated and
                  intensive Full Stack Web Developer course. I am dedicated to
                  constantly improving myself, working collaboratively in teams,
                  and pushing my boundaries. In the short and medium term, I aim
                  to enhance my software development skills and acquire
                  theoretical knowledge in the world of software. In the long
                  term, I aspire to advance in the field of software management,
                  where I can apply my learned skills and utilize my leadership
                  qualities.{" "}
                </p>
              ) : (
                <p>
                  İzmir Yüksek Teknoloji Enstitüsü'nden mezun oldum. Şu anda
                  Workintech tarafından sunulan 6 aylık hızlandırılmış ve yoğun
                  Full Stack Web Geliştirici kursuna kayıtlıyım. Sürekli olarak
                  kendimi geliştirmeye, ekiplerle işbirliği yapmaya ve
                  sınırlarımı zorlamaya adadım. Kısa ve orta vadede, yazılım
                  geliştirme becerilerimi geliştirmeyi ve yazılım dünyasındaki
                  teorik bilgiyi edinmeyi hedefliyorum. Uzun vadede ise, yazılım
                  yönetimi alanında ilerlemeyi hedefliyorum. Burada öğrendiğim
                  becerileri uygulayabileceğim ve liderlik niteliklerimi
                  kullanabileceğim bir pozisyonda ilerlemek istiyorum.{" "}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
